import { State } from 'src/redux/reducer';
import { isLoaded, isPending, isRejected, shouldLoad } from 'src/redux/utils';

export const editSurveysStatusSelector = (state: State) =>
  state.editSurveys.status;
export const editSurveysIdSelector = (state: State) =>
  state.editSurveys.entities;
export const editSurveysLoadedSelector = isLoaded(editSurveysStatusSelector);
export const shouldLoadEditSurveysSelector = shouldLoad(
  editSurveysStatusSelector,
);
export const editSurveysRejectedSelector = isRejected(
  editSurveysStatusSelector,
);
export const editSurveysPendingSelector = isPending(editSurveysStatusSelector);
